import { useState, useEffect } from 'react';

const deviceIs = () => {
  const deviceIs: { [key: string]: boolean } = {
    mobile: window.outerWidth <= 480,
    tablet: window.outerWidth > 480 && window.outerWidth <= 768,
    desktop: window.outerWidth > 768,
  }
  return Object.keys(deviceIs).find(key => deviceIs[key]) || '';
};
export const useDeviceDetect = () => {
  const [device, setDevice] = useState(deviceIs); 

  useEffect(() => {
    const handleDeviceDetection = () => setDevice(deviceIs);

    handleDeviceDetection();
    window.addEventListener('resize', handleDeviceDetection);

    return () => {
      window.removeEventListener('resize', handleDeviceDetection);
    };
  }, []);

  return device;
};